export default __webpack_public_path__ + "static/media/research.b73586d2.jpg";